import { Injectable } from '@angular/core';
import { NavigationStart, Router } from '@angular/router';
import { ModalController, ModalOptions } from '@ionic/angular';
import { filter } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class ModalService {
  public genericModal: any;

  private readonly openModals = new Set<HTMLIonModalElement>();

  constructor(
    private readonly modal: ModalController,
    private readonly router: Router
  ) {
    this.closeModalsOnNavigation();
  }

  public async openCustomModal(data: ModalOptions) {
    const modal = await this.modal.create(data);

    this.genericModal = modal;
    this.openModals.add(modal);
    void modal.onDidDismiss().then(() => this.openModals.delete(modal));

    await modal.present();
  }

  public closeModal() {
    return this.modal.dismiss();
  }

  private closeModalsOnNavigation(): void {
    this.router.events
      .pipe(filter((event) => event instanceof NavigationStart))
      .subscribe(() => {
        this.openModals.forEach((modal) => void modal.dismiss());
      });
  }
}
